import { useEffect, useState } from "react";
import API from "../../services/API";
import Layout from '../Frames/Layout'
import Grid from "../Tools/Grid";
import { Link } from "react-router-dom";
import { Link as A, Button, Chip, IconButton, Stack, Checkbox} from "@mui/material";
import moment from "moment";
import { LoadingButton } from "@mui/lab";
import Range from "../Inputs/Range";
import { Add, Delete, ZoomIn, Download } from "@mui/icons-material";
import ExportModal from "./Orders/ExportModal";

export default function Orders(){

    
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 60,
            type: 'number',
            aggregable: false,
            valueGetter: p => p.row.id,
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 160,
            type: 'date',
            aggregable: false,
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => !p.rowNode.isAutoGenerated && 
                moment(p.row.createdAt).format('DD/MM/YYYY à HH:mm')
        },
        {
            field: 'name',
            headerName: 'Nom',
            width: 160,
            type: 'string',
            aggregable: false,
            valueGetter: p => p.row.name,
            renderCell: p => <Link to={`/crm/persons/${p.row.user?.id}`}>
                <A component='span'>{p.row.user?.name}</A>
            </Link>
        },
        {
            field: 'amount',
            headerName: 'Montant €',
            width: 120,
            type: 'number',
           
            valueGetter: p => p.row.amount || 0,
        },
        {
            field: 'tax',
            headerName: 'TVA €',
            width: 120,
            type: 'number',
            valueGetter: p => p.row.tax || 0,
        },
        {
            field: 'status',
            headerName: 'Statut',
            width: 100,
            type: 'string',
            aggregable: false,
            valueGetter: p => p.row.status?.title,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                <Chip 
                    label={p.value}
                    color={p.value === 'En cours' ? 'warning' : 'success'}
                    size='small'
                />
        },
        {
            field: 'reference',
            headerName: 'Référence',
            width: 120,
            type: 'string',
            aggregable: false,
            valueGetter: p => p.row.reference
        },
        {
            field: 'detail',
            headerName: 'Détail',
            width: 60,
            aggregable: false,
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Link to={`/orders/${p.row.uuid}?readonly=1`}>
                    <IconButton size='small'>
                        <ZoomIn />
                    </IconButton>
                </Link>
        },
        {
            field: 'invoice',
            headerName: 'Facture',
            width: 80,
            aggregable: false,
            valueGetter: p => p.row.id,
            renderCell: p => !p.row.free && !p.rowNode.isAutoGenerated &&
                <IconButton size='small' onClick={() => handleInvoiceClick(p.row)}>
                    <Download />
                </IconButton>
        },
        {
            field: 'estimate',
            headerName: 'Devis',
            width: 60,
            aggregable: false,
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated &&!p.row.free && 
                <IconButton 
                    href={p.row.estimateUrl} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    download
                    size='small'
                >
                    <Download />
                </IconButton>
        },
        {
            field: 'paid',
            headerName: 'Payée',
            width: 60,
            aggregable: false,
            type: 'boolean',
            valueGetter: p => p.row.paid,
            renderCell: p => !p.rowNode.isAutoGenerated && !p.row.free &&
                <Checkbox 
                    checked={p.row.paid} 
                    size='small'
                    color='primary'
                    onClick={() => complete(p.row)}
                    disabled={p.row.paid}
                />
        },
        {
            field: 'payment',
            headerName: 'Demander le paiement',
            width: 200,
            aggregable: false,
            valueGetter: p => p.row.id,
            renderCell: p => (!p.rowNode.isAutoGenerated && (!p.row.free && !p.row.paid)) &&
                <LoadingButton
                    loading={loading === 'payment_' + p.row.id}
                    onClick={() => requestPayment(p.row)}
                    size='small'
                >
                    Demander
                </LoadingButton>
        },
        {
            field: 'remove',
            headerName: '',
            width: 60,
            aggregable: false,
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated && !p.row.completed && 
                <IconButton 
                    onClick={() => handleDelete(p.row)}
                    size='small'
                >
                    <Delete />
                </IconButton>
        },
    ];


    const [items, setItems] = useState(null)
    const [loading, setLoading] = useState(false)
    const [range, setRange] = useState(null)
    const [exportModal, setExportModal] = useState(false)

    useEffect(() => {

        let start = moment().add(-1, 'M').format('YYYY-MM-DD');
        let end = moment().format('YYYY-MM-DD');
        
        setRange({start, end})

        API.get(`/orders?start=${start}&end=${end}`)
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

    }, [])


    const handleDelete = order => {

        if(!window.confirm("Êtes-vous sûr de vouloir supprimer cette commande ?")){
            return false;
        }

        const old = [...items];
        let copy = [...items];
        copy = copy.filter(i => i.id !== order.id);
        setItems(copy)

        API.delete(`/orders/${order.uuid}`)
            .then(r => console.log(r.data))
            .catch(e => setItems(old))
    }

    const requestPayment = order => {

        const ok = window.confirm("Souhaitez-vous demander le paiement de cette commande ?");

        if(!ok) return false;

        setLoading('payment_' + order.id)

        API.post(`/orders/${order.uuid}/request`)
            .then(r => console.log(r.data))
            .catch(e => console.log(e.response?.data))
            .finally(() => setLoading(false))
    }

    const handleRangeChange = rng => {

        setRange(rng)
        setItems(null)

        API.get(`/orders?start=${rng.start}&end=${rng.end}`)
            .then(r => setItems(r.data))
            .catch(e => console.log(e.response?.data))

    }

    const complete = order => {

        const day = window.prompt("Date de solde :", moment().format('DD/MM/YYYY'));

        const pattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;

        if(!pattern.test(day)) return window.alert("La date n'est pas au bon format.");

        const d = day.split('/');
        const at = `${d[2]}-${d[1]}-${d[0]}`;

        const old = [...items];
        let copy = JSON.parse(JSON.stringify(items));

        const index = copy.findIndex(i => i.id === order.id);

        copy[index] = {...order, 
            completed: true, 
            paid: true, 
            status: {id: 'paid', title: 'Payée'},
            completedAt: `${at} 00:00:00`
        };

        setItems(copy)

        API.put(`/orders/${order.uuid}/complete?at=${at}`)
            .then(r => {
                console.log(r.data)
                let copy = JSON.parse(JSON.stringify(items));
                copy[index] = r.data;
                setItems(copy)
            })
            .catch(e => setItems(old))

    }

    const handleInvoiceClick = (order) => {
        if (!order.invoiceNumber) {
            const ok = window.confirm(`La génération de la facture créera une créance en comptabilité. Êtes-vous sûr de vouloir continuer ?`);
            if (!ok) return false;
        }
        API.download(`/orders/${order.uuid}/invoice/doc.pdf`);
    }


    return <Layout tab='orders' menu='crm' title='Commandes'>

        <Stack direction='row' justifyContent='space-between' alignItems='center' flexWrap='wrap'>

            <Range
                start={range?.start}
                end={range?.end}
                onChange={handleRangeChange}
                sx={{mb: 2}}
            />

            <Button
                startIcon={<Download />}
                onClick={() => setExportModal(true)}
            >
                Export de factures
            </Button>

            <Link to='/crm/orders/new'>
                <Button
                    variant='contained'
                    startIcon={<Add />}
                >
                    Ajouter
                </Button>
            </Link>

        </Stack>
        

        <Grid 
            id='ordersGrid231018'
            columns={columns}
            rows={items}
            toolbar
            aggregate={{amount: 'sum', tax: 'sum'}}
        />

        <ExportModal 
            open={exportModal}
            onClose={() => setExportModal(false)}
        />

    </Layout>

}